import React from 'react';
import SideSectionCurrentMatches from './SideSectionCurrentMatches';
import TeamNewsCard from './TeamNewsCard';

function TeamNews({ news, abbrv, loading, error, show }) {
  if (loading || error || !show) return null;

  return (
    <div className="row mt-3 mt-lg-4">
      <div className="col-12 col-lg-8">
        <div className="row">
          {news?.map((article, idx) => (
            <TeamNewsCard article={article} idx={idx} key={article.id} />
          ))}
        </div>
      </div>
      <div className="col-lg-4 d-none d-lg-block">
        <div className="col-12 d-flex align-items-center mb-4">
          <h2 className="heading-h3">AKTUELLA MATCHER</h2>
        </div>
        <div className="data-container">
          <SideSectionCurrentMatches abbrv={abbrv} />
        </div>
      </div>
    </div>
  );
}

export default TeamNews;
